import React, { useState } from 'react';
import CaretDown from '@assets/icons/caret-down';

export interface ProgressChartFilterItem<value> {
  label: string;
  value: value;
}

export interface ProgressChartFilterProps<value> {
  options: ProgressChartFilterItem<value>[];
  setSelection: (selected: value) => void;
  selected: value;
  label: string;
}

const ProgressChartFilter = (
  props: ProgressChartFilterProps<string | number>,
) => {
  const [openDropdown, setOpenDropdown] = useState(false);

  return (
    <div
      className={
        'flex gap-1 items-center relative text-neutral-chalk font-normal'
      }
      onClick={() => setOpenDropdown(!openDropdown)}
      data-testid={'toggle-button'}
    >
      <span>
        {props.label +
          props.options.filter(item => item.value === props.selected)[0].label}
      </span>
      <CaretDown
        className={
          'fill-current text-primary-apricot ml-2 w-2.5 transition-all ' +
          (openDropdown ? 'rotate-180' : '')
        }
      />
      {openDropdown ? (
        <div
          className={
            'absolute z-10 top-8 left-0 w-full bg-primary-navyblue-dim border border-neutral-chalk rounded-2xl overflow-auto'
          }
          data-testid={'dropdown-chart'}
        >
          {props.options.map(item => {
            return (
              <div
                className={
                  'text-left py-2 px-4 hover:bg-primary-navyblue-bright'
                }
                onClick={() => props.setSelection(item.value)}
                key={item.value}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ProgressChartFilter;
